import React from 'react'
import Icon from 'react-icon-base'

const Belongs = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g id="Belongs" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Belongs" transform="translate(-4.000000, -5.000000)">
        <g id="Group" transform="translate(4.000000, 5.000000)">
          <rect
            id="Rectangle"
            stroke="#3498DB"
            strokeWidth="2"
            transform="translate(16.500000, 15.500000) rotate(90.000000) translate(-16.500000, -15.500000) "
            x="5"
            y="0"
            width="23"
            height="31"
            rx="2"
          />
          <g
            id="Page-1-Copy-2"
            transform="translate(4.000000, 10.000000)"
            stroke="#3498DB"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5">
            <path
              d="M7.78733033,3.11898851 C7.78733033,1.5736012 6.53411694,0.320387806 4.98872964,0.320387806 C3.44334233,0.320387806 2.19012894,1.5736012 2.19012894,3.11898851 C2.19012894,4.66437581 3.44334233,5.91758921 4.98872964,5.91758921 C6.53411694,5.91758921 7.78733033,4.66437581 7.78733033,3.11898851 Z"
              id="Stroke-1"
            />
            <path
              d="M9.78133333,10.7101929 C9.78133333,8.06355622 7.63536632,5.91758921 4.98872964,5.91758921 C2.34209295,5.91758921 0.196125937,8.06355622 0.196125937,10.7101929"
              id="Stroke-3"
            />
          </g>
          <line
            x1="16.5"
            y1="12.5"
            x2="28.5"
            y2="12.5"
            id="Line-2"
            stroke="#3498DB"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <line
            x1="16.5"
            y1="9.5"
            x2="22.5"
            y2="9.5"
            id="Line-2-Copy-4"
            stroke="#3498DB"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <line
            x1="16.5"
            y1="15.5"
            x2="28.5"
            y2="15.5"
            id="Line-2-Copy"
            stroke="#3498DB"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <line
            x1="16.5"
            y1="18.5"
            x2="28.5"
            y2="18.5"
            id="Line-2-Copy-2"
            stroke="#3498DB"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <line
            x1="16.5"
            y1="21.5"
            x2="28.5"
            y2="21.5"
            id="Line-2-Copy-3"
            stroke="#3498DB"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <rect id="Rectangle" fill="#3498DB" x="11" y="2" width="11" height="4" rx="2" />
          <circle id="Oval" stroke="#3498DB" cx="16.5" cy="2.5" r="2" />
        </g>
      </g>
    </g>
  </Icon>
)
Belongs.defaultProps = {
  size: 30
}

export default Belongs
